import React from 'react'
import {Snack} from './Snack'
import {ViewErrorBoundary} from './ViewErrorBoundary'
import {ThemeProvider, CssBaseline, StyledEngineProvider} from '@mui/material'
import {observer} from 'mobx-react-lite'
import {ViewLoadContextProvider} from './ViewLoader/ViewLoadContext'
import {CustomerRouteContextProvider} from './CustomerContext'
import {FileSelectContextProvider} from './FileSelect'
import {ConfirmContextProvider, ConfirmPrompt} from './ConfirmPrompt'
import {UserPermissionsContextProvider} from './UserPermissionsContext'
import {EventBusContextProvider} from './EventBus'
import {CustomerService, ReadyKitService} from '@oc/customer'
import {UserManagementService} from '@oc/user-management'
import {defaultTheme, ocTheme} from '@oc/styles'
import {DateTimezoneStateContextProvider} from './DatetimeTimezoneStateContext'
import {AppDrawerContextProvider} from './AppDrawerContext'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFnsV3'
import {ValidationContextProvider} from './ModulesValidation/ValidationErrorDialog'

function AppMainComponent({children}: React.PropsWithChildren) {
    return (
        <MiscProviders>
            {children}
            <ConfirmPrompt />
        </MiscProviders>
    )
}

function MiscProviders(props: React.PropsWithChildren) {
    const providers = [
        [CssBaseline],
        [StyledEngineProvider, {injectFirst: true}],
        [Snack],
        [UserPermissionsContextProvider, {service: new UserManagementService()}],
        [ThemeProvider, {theme: defaultTheme}],
        [LocalizationProvider, {dateAdapter: AdapterDateFns}],
        [EventBusContextProvider],
        [
            CustomerRouteContextProvider,
            {customerService: new CustomerService(), readykitService: new ReadyKitService()}
        ],
        [FileSelectContextProvider],
        [ConfirmContextProvider],
        [DateTimezoneStateContextProvider],
        [AppDrawerContextProvider],
        [ViewLoadContextProvider],
        [ValidationContextProvider],
        [ViewErrorBoundary]
    ]

    const providerAt = (idx: number): any => {
        const provider: any = providers[idx]
        if (!provider) {
            return props.children
        }

        return React.createElement(provider[0], provider[1], providerAt(idx + 1))
    }

    return providerAt(0)
}

function _OcThemeProvider(props: React.PropsWithChildren) {
    const providers = [[ThemeProvider, {theme: ocTheme}]]

    const providerAt = (idx: number): any => {
        const provider: any = providers[idx]
        if (!provider) {
            return props.children
        }

        return React.createElement(provider[0], provider[1], providerAt(idx + 1))
    }

    return providerAt(0)
}

export const OcThemeProvider = observer(_OcThemeProvider)

export default observer(AppMainComponent)
